import CardView from "../../../components/Views/CardView";
import {Button, Card, CardActions, CardContent, CardMedia, Typography} from "@mui/material";
import {useRef} from "react";
import AttractionData from "./AttractionsData";


export const PropCard = ({obj, editHandler = null, deleteHandler = null}) => <Card sx={{ width: '100%' }}>
    <CardMedia
        component="img"
        height="300"
        image={obj.image}
        alt={obj.name}
    />
    <CardContent>
        <Typography variant="h5" component="div">
            {obj.name}
        </Typography>
        <hr/>
        <Typography variant="body2" color="text.secondary">
            {obj.description}
        </Typography>
    </CardContent>
    <CardActions>
        <Button size="small" variant="outlined" color="success" onClick={editHandler}>Szerkesztés</Button>
        <Button size="small" variant="outlined" color="error" onClick={deleteHandler}>Törlés</Button>
    </CardActions>
</Card>


const Attractions = () => {
    const eventForm = useRef(null)
    return <CardView
        title='látványosság'
        imageFiledName="image"
        pluralTitle='Látványosságok'
        baseSlug='attractions'
        PropCard={PropCard}
        formRef={eventForm}
        form={<AttractionData reference={eventForm}/>}
    />
}

export default Attractions